import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardPage } from './dashboard.page';
import { APP_ROUTES } from 'src/app/util/constants';

const routes: Routes = [

  {
    path: 'dashboard',
    component: DashboardPage
  },
  {
    path: APP_ROUTES.REPORT,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../report/report.module').then((m) => m.ReportPageModule),
      },
    ],
  },
  {
    path: APP_ROUTES.SETTINGS,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../settings/settings.module').then(
            (m) => m.SettingsPageModule
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.CLEAN_CALC,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../calculator/clean-calc/clean-calc.module').then(
            (m) => m.CleanCalcModule
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.EMI_CALC,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../calculator/emiCalc/emi-calc.module').then(
            (m) => m.EmiCalcModule
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.CURRENCY_CONVERTER,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../calculator/currency-converter/currency-converter.module').then(
            (m) => m.CurrencyConverterModule
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.COMPOUND_INTEREST,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../calculator/compound-interest/compound-interest.module').then(
            (m) => m.CompoundInterestModule
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.ABOUT,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../about/about.module').then((m) => m.AboutPageModule),
      },
    ],
  },
  {
    path: APP_ROUTES.ADD_BILL,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../add-bill/add-bill.module').then(
            (m) => m.AddBillPageModule
          ),
      },
    ],
  },
  {
    path: APP_ROUTES.CALENDAR_OVERVIEW,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../calendar-overview/calendar-overview.module').then(
            (m) => m.CalendarOverviewModule
          ),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardPageRoutingModule {}
